import { Component, createRef, Fragment } from 'react';
import classNames from 'classnames/bind';
import filter from 'lodash-es/filter';
import autoBind from 'react-autobind';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as authentication from '../../../actions/authentication.actions';

import getPriceInfo from '../helpers/getPriceInfo';

import PricingPlanSubscribeOption from '../PricingPlanSubscribeOption';
import withComponentName from '../../../decorators/withComponentName';
import withPriceCurrency from '../PriceCurrencyProvider/withPriceCurrency';
import Tooltip from '../../Tooltip';

import { BASIC_PLAN, GUEST_PLAN } from '../../../data/subscriptionPlans';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

class PlanItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    autoBind(this);
    this.pricingHeaderRef = createRef();
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    const { promoHeight } = this.props;

    const storiesTop = this.pricingHeaderRef.current.getBoundingClientRect().top;
    const isHeaderFixed = (storiesTop - 80 - promoHeight) <= 0;

    this.setState({
      isHeaderFixed,
    });
  }

  openSignModal() {
    const { actions } = this.props;
    actions.setAuthModalOpened(true);
  }

  createListElement(featuresList) {
    return featuresList.map((item, index) => (
      <li key={index} className={item.display_inline ? Styles.with_link : ''}>
        {item.feature.map((value, index) => (
          <Fragment key={index}>
            {value instanceof Object && value.href && (
              <a href={value.href} key={`link_${index}`}>{value.text}</a>
            )}
            {!(value instanceof Object) && (
              <p
                key={`text_${index}`}
                className={
                  item.display_block ? Styles.display_block_text
                    : item.display_inline
                      ? Styles.display_inline_text : ''
                }
              >
                {value}
              </p>
            )}
            {value instanceof Object && value.hasToolTip && (
              <span key={`icon_${index}`} className={Styles.plan_tooltip_holder}>
                <Tooltip className={Styles.plan_tooltip}>{value.tooltipText}</Tooltip>
              </span>
            )}
          </Fragment>
        ))}
      </li>
    ));
  }

  handleSubscriptionClick() {
    const {
      activePlane,
      activePlaneType,
      planPriceInfo,
      onSubscribe,
    } = this.props;
    const foundPlan = planPriceInfo
      .find((f) => f.plan_type === activePlaneType && f.plan_key === activePlane);
    onSubscribe(foundPlan);
  }

  render() {
    const {
      images,
      text,
      features,
      basic = false,
      silver = false,
      gold = false,
      width,
      userPlan,
      current_plan,
      planPriceInfo,
      head_title,
      isUserWithPlan,
      promoHeight,
      activePlane, activePlaneType, isAddOnActive, addOnType,
      updateParentState, onSubscribe, userPlanType, hasInsightsAccess,
      currencyShort,
      currencySymbol,
      currency,
    } = this.props;

    const { isHeaderFixed } = this.state;

    const planImg = cx('plan_img', {
      basic,
      silver,
      gold,
    });

    const pricingPlansInner = cx('pricing_plan_inner', {
      guest: userPlan === GUEST_PLAN,
      'registered-user-plan': isUserWithPlan,
      'user-gold-plan': userPlan === 'gold_plan' && gold,
      'user-silver-plan': userPlan === 'silver_plan' && silver,
      'user-basic-plan': userPlan === 'basic_plan' && basic,
      gold,
      basic,
      silver,
      active: activePlane === current_plan,
      is_fixed: isHeaderFixed,
    });

    const planTitleClass = cx('plan_title', {
      'gold-plan-title': gold,
      'basic-plan-title': basic,
      'silver-plan-title': silver,
    });

    const activeFeatures = filter(features, (f) => !f.coming_soon);
    const comingFeatures = filter(features, 'coming_soon');

    const isDesktop = width > 768;
    let topHeight;
    const headerHeight = width > 767 ? 80 : 50;
    if (isDesktop || promoHeight) {
      topHeight = headerHeight + promoHeight;
    } else {
      topHeight = promoHeight;
    }

    const foundActivePlan = planPriceInfo
      .find((f) => f.plan_type === activePlaneType && f.plan_key === activePlane);
    let totalMainPrice = 0;
    let totalSubPrice = 0;
    let totalSubText = '';
    if (foundActivePlan) {
      const valueSuffix = currency === 'gbp' ? '_gbp' : '';
      totalMainPrice = foundActivePlan[`price${valueSuffix}`] + (isAddOnActive ? foundActivePlan[`add_on_${addOnType}${valueSuffix}`] : 0);
      totalSubPrice = (foundActivePlan[`total${valueSuffix}`] || 0) + (isAddOnActive ? foundActivePlan[`total_${addOnType}${valueSuffix}`] : 0);
      totalSubText = foundActivePlan.total_sub_text;
    }

    const {
      smallestPrice,
      largestPrice,
    } = getPriceInfo({
      basic,
      planPriceInfo,
      currency,
    });

    return (
      <div className={pricingPlansInner} ref={this.pricingHeaderRef}>
        <div
          className={cx('plan-header')}
          style={{
            top: `${topHeight}px`,
            zIndex: 1,
            position: 'sticky',
          }}
        >
          <h2>{head_title}</h2>
        </div>
        <div className={Styles['plan-body']}>
          <div className={Styles['plan-body-inner']}>
            <div className={planTitleClass}>
              {basic && <p>{text}</p>}
              {!basic && (
                <div className={Styles['price-start']}>
                  <div className={Styles.value}>
                    <span className={Styles.cost}>
                      {currencySymbol}
                      {`${smallestPrice}${largestPrice !== smallestPrice ? `-${largestPrice}` : ''}`}
                    </span>
                    {' '}
                    {currencyShort}
                    /mo
                  </div>
                  {silver && (
                    <div className={Styles['silver-trial-badge']}>
                      {(width > 1250 || activePlane === current_plan) && (
                        <>
                          Try 7-days
                          {' '}
                        </>
                      )}
                      FREE trial!
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className={planImg}>
              <picture className="text-center">
                <source media="(max-width: 767px)" srcSet={images.smallImg} />
                <source media="(max-width: 1023px)" srcSet={images.mediumImg} />
                <img src={images.bigImg} alt="Blue bird" />
              </picture>
            </div>
            <div className={Styles.plan_features}>
              {silver && (
                <p className={Styles.plan_features_title}>Everything in the BASIC plan plus:</p>
              )}
              {gold && (
                <p className={Styles.plan_features_title}>Everything in the SILVER plan plus:</p>
              )}
              <ul className={`${Styles.plan_features_main} d-flex`}>
                {this.createListElement(activeFeatures)}
              </ul>
              {!basic && (
                <div className={Styles['coming-soon-features']}>
                  <span className={Styles['coming-soon-features-title']}>Features Coming Soon:</span>
                  <ul className="d-flex">
                    {this.createListElement(comingFeatures)}
                  </ul>
                </div>
              )}
            </div>
          </div>
          <div
            className={cx('prices', { 'basic-plan': basic })}
            id={current_plan === BASIC_PLAN ? 'sub_plans_pricing' : undefined}
          >
            {Array.isArray(planPriceInfo) && planPriceInfo.map((priceInfo) => (
              <PricingPlanSubscribeOption
                priceInfo={priceInfo}
                key={priceInfo.id}
                isUserWithPlan={isUserWithPlan}
                text={text}
                currentPlan={current_plan}
                width={width}
                gold={gold}
                silver={silver}
                onSubscribe={onSubscribe}
                basic={basic}
                userPlan={userPlan}
                userPlanType={userPlanType}
                activePlane={activePlane}
                activePlaneType={activePlaneType}
                isAddOnActive={isAddOnActive}
                addOnType={addOnType}
                updateParentState={updateParentState}
                hasInsightsAccess={hasInsightsAccess}
              />
            ))}
            {activePlane === current_plan && current_plan === BASIC_PLAN && (
              <div className={Styles['price-option-holder']}>
                <SubscribeButton
                  onSubscribe={this.handleSubscriptionClick}
                  silver={silver}
                />
                <div className={Styles['price-option-text']}>
                  <div className={Styles['price-option-text-main']}>
                    {currencySymbol}
                    0&nbps;
                    {currencyShort}
                    /month
                  </div>
                </div>
              </div>
            )}
          </div>
          {activePlane === current_plan && current_plan !== BASIC_PLAN && (
            <div className={Styles['price-option-holder']}>
              <SubscribeButton
                onSubscribe={this.handleSubscriptionClick}
                silver={silver}
              />
              <div className={Styles['price-option-text']}>
                <div className={Styles['price-option-text-main']}>
                  {currencySymbol}
                  {totalMainPrice}
                  {' '}
                  {currencyShort}
                  /month
                </div>
                {totalSubText && (
                  <div className={Styles['price-option-text-sub']}>
                    {!!totalSubPrice && (
                      <>
                        {currencySymbol}
                        {totalSubPrice}
                        {' '}
                      </>
                    )}
                    {totalSubText}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const SubscribeButton = ({
  silver, onSubscribe, longTermBtnOption,
}) => {
  const btnText = silver
    ? 'Start Free Trial'
    : 'Subscribe';
  return (
    <button
      type="button"
      onClick={onSubscribe}
      className={cx('price-option-btn', { 'long-term-option': longTermBtnOption })}
    >
      {btnText}
    </button>
  );
};

const mapStateToProps = (state) => ({
  promoHeight: state.promobar.height,
  width: state.common.width,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    ...authentication,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withComponentName(
    withPriceCurrency(PlanItem),
  ),
);
